import React, { useEffect } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";
import PaperRecibo from "./PaperRecibo";
import useContract from "../../hooks/useContract";
import getStepsContract from "components/Contract/getStepsContract";
import useClient from "hooks/useClient";
import SnackBarWiiba from "components/Snackbar/SnackBarWiiba";
import useMessage from "../../hooks/useMessage";
import useDevelop from "../../hooks/useDevelop";
import useBlocks from "../../hooks/useBlocks";
import useLot from "../../hooks/useLot";
//import useInsertacontract from "../../hooks/useInsertaContract";
import useDocumentContract from "hooks/useDocumentContract";
import usePayment from "hooks/usePaymenth";

const useStyles = makeStyles(theme => ({
  ...dashboardStyle,
  root: {
    width: "100%"
  },
  button: {
    marginTop: theme.spacing(1),
    marginRight: theme.spacing(1)
  },
  actionsContainer: {
    marginBottom: theme.spacing(2)
  },
  resetContainer: {
    padding: theme.spacing(3)
  },
  rootRadio: {
    "&:hover": {
      backgroundColor: "transparent"
    }
  },
  icon: {
    borderRadius: "50%",
    width: 16,
    height: 16,
    boxShadow:
      "inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)",
    backgroundColor: "#f5f8fa",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))",
    "$root.Mui-focusVisible &": {
      outline: "2px auto rgba(19,124,189,.6)",
      outlineOffset: 2
    },
    "input:hover ~ &": {
      backgroundColor: "#ebf1f5"
    },
    "input:disabled ~ &": {
      boxShadow: "none",
      background: "rgba(206,217,224,.5)"
    }
  },
  checkedIcon: {
    backgroundColor: "#137cbd",
    backgroundImage:
      "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
    "&:before": {
      display: "block",
      width: 16,
      height: 16,
      backgroundImage: "radial-gradient(#fff,#fff 28%,transparent 32%)",
      content: '""'
    },
    "input:hover ~ &": {
      backgroundColor: "#106ba3"
    }
  }
}));
export default function Contract() {
  const classes = useStyles();

  const steps = ["Consulta Cliente", "Asigna el Lote", "Verifica los Datos"];

  const {
    opensnack,
    typesnackbar,
    message,
    handleMuestraSnack,
    handleClosesSnack
  } = useMessage();

  const {
    handleReset,
    handleBack,
    handleNext,
    activeStep,
    botonSigDisabled,
    setBotonSigDisabled,
    setBackDisabled,
    backDisabled
  } = useContract({ handleMuestraSnack });

  const { getLots, idLot, lot, onChangeLot, infolot } = useLot({
    handleMuestraSnack,
    setBotonSigDisabled
  });

  const { getBlocks, blocks, idBlock, onChangeBlock } = useBlocks({
    handleMuestraSnack
  });

  const { developments, getDevelopments } = useDevelop({ handleMuestraSnack });

  const {
    selectedRow,
    column,
    clientes,
    onRowClick,
    handleSearchClient,
    direccion,
    modalNuevoCliente,
    setModalNuevoCliente
  } = useClient({ handleMuestraSnack, setBotonSigDisabled });

  /*const { handleInsertaContrato } = useInsertacontract({
    handleMuestraSnack,
    setBotonSigDisabled
  });*/

  const { generatePdf, generateReciboPdf } = useDocumentContract();
  const { paymentMade, handleGenerateContract, infoContract } = usePayment({
    handleMuestraSnack,
    setBotonSigDisabled,
    setBackDisabled
  });

  useEffect(() => {
    getDevelopments();
  }, []);

  return (
    <div className={classes.root}>
      <SnackBarWiiba
        opensnack={opensnack}
        tipoSnackBar={typesnackbar}
        mensaje={message}
        handleClosesSnack={handleClosesSnack}
      />

      <Stepper activeStep={activeStep} orientation={"vertical"}>
        {steps.map((label, step) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
            <StepContent>
              <Typography component={"span"}>
                {getStepsContract({
                  step,
                  selectedRow,
                  column,
                  clientes,
                  onRowClick,
                  handleSearchClient,
                  getLots,
                  idLot,
                  lot,
                  onChangeLot,
                  getBlocks,
                  blocks,
                  idBlock,
                  onChangeBlock,
                  developments,
                  getDevelopments,
                  infolot,
                  direccion,
                  generatePdf,
                  paymentMade,
                  handleGenerateContract,
                  modalNuevoCliente,
                  setModalNuevoCliente
                })}
              </Typography>
              <div className={classes.actionsContainer}>
                <div>
                  <Button
                    disabled={activeStep === 0 || backDisabled}
                    onClick={handleBack}
                    className={classes.button}
                  >
                    Atras
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleNext}
                    className={classes.button}
                    disabled={botonSigDisabled}
                  >
                    {activeStep === steps.length - 1
                      ? "Finalizar"
                      : "Siguiente"}
                  </Button>
                </div>
              </div>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      {activeStep === steps.length && (
        <>
          <PaperRecibo
            infoContract={infoContract}
            generateReciboPdf={generateReciboPdf}
          />
          <Button onClick={handleReset} className={classes.button}>
            Reiniciar
          </Button>
        </>
      )}
    </div>
  );
}
